import { InjectionToken } from '@angular/core';

/** L'adresse d'un onglet de démonstration : `/decouverte/<domaine>/<cas-d-usage>`. */
export const DEMO_PATH_PREFIX = '/decouverte/';

/** Garde le parcours de l'onglet d'un rechargement à l'autre, pour cet onglet seul. */
const DEMO_STORAGE_KEY = 'cdt.demonstration';

/** Le parcours que joue cet onglet de démonstration ; absent d'un onglet ordinaire. */
export const DEMO_TOUR_ID = new InjectionToken<string>('DEMO_TOUR_ID');

export type TabStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** `sessionStorage`, s'il est accessible : il peut lever une exception en navigation restreinte. */
export function tabStorage(): TabStorage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

/**
 * Le parcours de démonstration de cet onglet, décidé une fois, au démarrage : l'adresse
 * `/decouverte/…` l'ouvre, et l'onglet le garde ensuite, rechargement compris, même une fois le
 * parcours parti vers la liste des contrats. `null` pour un onglet ordinaire.
 */
export function demoTourId(pathname: string, storage: TabStorage | null): string | null {
  if (pathname.startsWith(DEMO_PATH_PREFIX)) {
    const id = decodeURIComponent(pathname.slice(DEMO_PATH_PREFIX.length)).replace(/\/+$/, '');
    try {
      storage?.setItem(DEMO_STORAGE_KEY, id);
    } catch {
      // Sans stockage, l'onglet sort de la démonstration au prochain rechargement.
    }
    return id;
  }
  try {
    return storage?.getItem(DEMO_STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

/**
 * Sort l'onglet de la démonstration : au prochain démarrage, il est ordinaire. Seul « Quitter la
 * démonstration » l'oublie (RG-parcours-donnees-fictives).
 */
export function forgetDemo(storage: TabStorage | null): void {
  try {
    storage?.removeItem(DEMO_STORAGE_KEY);
  } catch {
    // Sans stockage, rien n'était retenu.
  }
}
